import { clamp } from '../../viewer/utilities/math-helpers';

type ProgressCallback = (progress: number, text?: string) => void;

/**
 * Used together with promises to keep track of aborted state.
 */
export class ProgressController {
  private stepCount = 1;
  private maxStepCount = 1;
  callback: ProgressCallback;

  get step() {
    return `(${this.stepCount}/${this.maxStepCount})`;
  }

  constructor(callback?: ProgressCallback, maxStepCount?: number) {
    this.callback =
      callback ??
      (() => {
        /*  */
      });
    this.maxStepCount = maxStepCount ?? 1;
  }

  reset() {
    this.stepCount = 1;
  }

  incrementStep() {
    this.stepCount++;
  }

  next() {
    this.stepCount++;
    this.callback(clamp(this.stepCount / this.maxStepCount, 0, 1));
  }
}
